<template>
  <div class="pageContent" style="position:absolute;">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">支付房费</span>
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />

      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>

    <div style="width:100% ; " align="center">

      <div style="font-size:0.22rem ; color:#99999 ; margin-top:0.3rem">
        订单号： {{ g_PayOrder.OrderId }}
      </div>
      <br />

      <div style="color:#27BA69 ; font-weight:bold ;  margin-bottom:0.2rem ">
        <nobr style="font-size:0.35rem">￥</nobr>
        <nobr style="font-size:0.72rem">{{ g_PayOrder.Money | fomatFloat}} </nobr>
      </div>

      <div style="height:0.1rem"> </div>

      <!--线条-->
      <!--<hr style="border:none; border-top:1px solid #F1F1F1;"></hr>-->
      <!--{{QuickPay}}-->
      <div v-show="QuickPay==1 " style=" width:92%  ;  color:#999999 ;  font-size:0.22rem  ;margin-bottom:0.3rem ; margin-top:0.3rem ;   " align="left">
        备注：支付成功后，如遇特殊情况，不能及时入住，您可以在
        <span class="Orange" style="font-weight:600">{{ g_PayOrder.Date | dayDate}} &nbsp; 18:00 </span>
        前免费取消订单。若未入住或过时取消将收取您首日房费。
      </div>

      <div v-show="QuickPay==2 " style=" width:92%  ;  color:#999999 ;  font-size:0.22rem  ;margin-bottom:0.3rem ; margin-top:0.3rem ;   " align="left">
        备注：请在30分钟内完成支付，否则订单会自动取消。
      </div>

      <div v-show="QuickPay==0 " style=" width:92%  ;  color:#999999 ;  font-size:0.22rem  ;margin-bottom:0.3rem ; margin-top:0.3rem ;   " align="left">
      </div>

      <!--<span class="Orange" style="font-weight:600">{{g_PayOrder.Date | dayDate}} &nbsp; 18:00 </span>-->

      <!--灰条-->
      <div style=" background-color: #F5F5F5 ;height: 0.2rem"></div>

      <div align="left" style=" width:100% ; margin-top:0.3rem">

        <div style=" margin-left:0.3rem">
          支付方式
        </div>

        <div style=" width:100% " align="center">
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin:2.1rem auto 0 auto" v-show="  IsLoading  " />
        </div>

        <div style=" width:100% "  v-show=" !IsLoading  " >

          <mu-list style="font-size:0.3rem">
            <div v-if="loginState">
              <mu-list-item v-on:click="goPay(1)">
                <img src="../../../static/order/SmallStore.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
                <span class='title'>储值卡支付
                  <nobr class="Orange" style="  "> 充1000送1000K币 </nobr>
                </span>
                <mu-icon slot="right" value="keyboard_arrow_right" />
              </mu-list-item>
              <mu-divider />
            </div>
            <mu-list-item v-on:click="goPay(2)" v-if="loginState">
              <img src="../../../static/order/SmallUnionPay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
              <span class='title'>银联支付</span>
              <mu-icon slot="right" value="keyboard_arrow_right" />
            </mu-list-item>
            <mu-list-item v-on:click="goPay(5)" v-else>
              <img src="../../../static/order/SmallUnionPay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
              <span class='title'>银联支付</span>
              <mu-icon slot="right" value="keyboard_arrow_right" />
            </mu-list-item>
            <mu-divider />
            <mu-list-item v-on:click="goPay(3)" v-bind:style="{display:allowAlipay}">
              <img src="../../../static/order/SmallAlipay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
              <!--<mu-avatar src="../../../static/wallet/bankcard.png" backgroundColor="transparent"  slot="left"   />-->
              <mu-icon slot="right" value="keyboard_arrow_right" />
              <span class='title'>支付宝支付</span>
            </mu-list-item>
            <mu-divider v-bind:style="{display:allowAlipay}"/>
            <mu-list-item v-on:click="goPay(6)" v-bind:style="{display:allowWepay}">
              <img src="../../../static/order/wepay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
              <mu-icon slot="right" value="keyboard_arrow_right" />
              <span class='title'>微信支付</span>
            </mu-list-item>
            <mu-divider v-bind:style="{display:allowWepay}"/>
            <mu-list-item v-on:click="goPay(4)">
              <img src="../../../static/order/SmallOtherPay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
              <mu-icon slot="right" value="keyboard_arrow_right" />
              <span class='title'>他人代付</span>
            </mu-list-item>
            <mu-divider />
          </mu-list>

        </div>

      </div>
    </div>

    <!--弹出框-->
    <mu-toast v-if="toast" :message="TellUser" @close="hideToast" id="alertline" />

    <mu-dialog :open="dialog" @close="close">
      <div style='color:#666666;text-align:center;'>抱歉，您尚未开通储值卡！</div>
      <mu-flat-button slot="actions" @click="goOpenValue" primary label="去开通"/>
      <mu-flat-button slot="actions" primary @click="close" label="取消"/>
    </mu-dialog>
  </div>
</template>








<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'


export default {
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder'
    ])
  },
  activated() {

    this.IsLoading = true;

    this.QuickPay = 0;

    this.valueOpen = false
    // this.CheckOrder();
    this.GetWaitingForPay();

    this.checkValueCard()
    //获取登录状态
    var params = new this.URLSearchParam();
    params.append('cardNo', this.g_UserInfo.Card_no ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {
      if (res.Result) {
        this.loginState = true
      }
      else {
        // this.$http.post(api.LogOff()).then((res) => { });
        // this.$store.commit('CLEARUSER');
        this.loginState = false;
      }
    });

    // 非会员 ， 半小时内支付，会员，休闲房，活动房，半小时内支付 。    会员 非活动房 常规支付
  },
  data() {
    return {
      IsLoading: true,

      loginState: false,

      dialog: false,

      QuickPay: 0,

      // 储值卡开通状态
      valueOpen:false,

      // 弹出层
      TellUser: '',
      toast: false,
      // 弹出标签 选择是否
      dialog: false,
      allowWepay:typeof WeixinJSBridge == "undefined"?'none':'block',
      allowAlipay:typeof WeixinJSBridge == "undefined"?'block':'none'
    }
  },
  methods: {
    ...mapMutations([
      'setG_PayOrder',
    ]),
    //开通储值卡
    goOpenValue(){
      this.close()
      this.$router.push({ path: '/wallet/openValueCard' })
    },
    GetWaitingForPay() {
      // 这就是获取订单价格的接口
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);

      this.$http.post(api.GetWaitingForPay(), params.toParam()).then((res) => {
        if (res.Result) {
          var Order = this.g_PayOrder;

          // Order.PayFor = "PayMent";
          Order.Money = res.Data;
          this.setG_PayOrder(Order);
        }
        else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }
      })

      // 获取是否用了银联券
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('phoneNo', this.g_UserInfo.OtherUserID);

      this.$http.post(api.getOrderDetail(), params.toParam()).then((res) => {
        if (res.Result) {

          var Order = this.g_PayOrder;
          Order.TypeId = 0
          Order.UsingUnionCash = res.Data.UsingUnionCash;
          Order.IsSpecialRoom = res.Data.IsSpecialRoom;

          this.setG_PayOrder(Order);


          // 登录的用户，房间不是休闲房，也不是活动房
          if (this.loginState == true && !this.g_PayOrder.IsSpecialRoom && res.Data.Note.indexOf("[休闲房]") == -1) {
            this.QuickPay = 1;
            console.log(1)
          }
          else {
            this.QuickPay = 2;
            console.log(2)
          }

          this.IsLoading = false;

        }
        else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }
      })

    },
    //跳转登录页面
    goLogin(){
      var that = this;
      setTimeout(function() {
        that.$router.push({ path: "/user/Login" })
      }, 2000);
    },
    //检查储值卡是否开通，开通跳转否则弹出对话框
    checkValueCard(){
      if(typeof this.g_UserInfo.HasOpenStoreCard === "undefined"){
        this.showToast('您的用户信息已过期，请重新登录！');
        //清空信息缓存
        this.$store.commit('CLEARUSER');
        //跳转登录
        this.goLogin();
        return;
      }
      else{
        this.valueOpen = this.g_UserInfo.HasOpenStoreCard
      }
    } ,    

    goPay(val) {
      if (val == 1 || val == 3 || val == 4) {
        if (this.g_PayOrder.UsingUnionCash == undefined) {

          this.TellUser = "正在获取信息"
          this.showToast();
          return
        }
        if (this.g_PayOrder.UsingUnionCash) {

          this.TellUser = "请用银联支付"
          this.showToast();
          return
        }
      }

      var Order = this.g_PayOrder;

      if (val == 1) {
        if(!this.valueOpen){
          this.open()
          return
        }
        Order.PayType = "储值卡支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: '/order/PayByStoredValueCard' });
      }
      else if (val == 2) {
        Order.PayFor = "PayMent";

        Order.PayType = "银联支付";
        this.setG_PayOrder(Order);

        this.$router.push({ path: '/order/PayByUnion/ChooseCard' });

      }
      // 这页面不用了
      else if (val == 3) {
        Order.PayType = "支付宝支付";
        this.setG_PayOrder(Order);
        // this.$router.push({ path: '/PayMent/AliPay?parentNo='+  this.g_PayOrder.OrderId  +'&payType=1' });

        window.location.href = '/apis/PayMent/PayByAlipay?parentNo=' + this.g_PayOrder.OrderId + '&payType=1';

        // var params = new this.URLSearchParam();
        // params.append('parentNo', this.g_PayOrder.OrderId)
        // params.append('payType', 1)

        // this.$http.post(api.PayByAlipayHotel(), params.toParam()).then((res) => {
        //   console.log(res)
        //   if (res.Result) {
        //     // this.$router.push({ path: '/order/PayByUnion/ChooseCard' });
        //     window.location.href = res.Data;
        //   }
        //   else {
        //     //调用弹出层
        //     this.TellUser = res.Message;
        //     this.showToast();
        //   }
        // })

      }
      else if (val == 4) {
        Order.PayType = "他人支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: '/order/PayByOther' });
      }
      // 未登录用户点击，不跳入选卡页面，直接去输入卡号
      else if (val == 5) {
        Order.PayFor = "PayMent";
        Order.PayType = "银联支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: '/order/PayByUnion/BeforeBind' });
      }else if(val==6){
        window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http://h5.998.com/kosmos/WeChat/GetCodeReturn&response_type=code&scope=snsapi_base&state="+this.g_PayOrder.OrderId+"#wechat_redirect";
      }

      console.log(this.g_PayOrder)
    },

    goback() {
      javascript: history.go(-1);
    },



    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    }
  },





}
</script>




// paper模块
<style lang="less" scoped>
@import "../../assets/theme.less";
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// PayMoney.vue?65c0721e